import React, { createContext, useCallback, useContext } from 'react';
import { useMessage } from './MessageContext';
import { usePrinter } from './PrinterContext';
import { buscarResumoCaixaPdf } from '../../services/caixas/CaixaResumoService';

// Criar o contexto para o resumo de caixa
const PrinterCaixaContext = createContext();

export const PrinterCaixaProvider = ({ children }) => {
    const { showMessage } = useMessage();
    const { imprimirPdfBlob } = usePrinter();

    // Função para solicitar ao backend e imprimir o PDF do resumo de caixa
    const printResumoCaixa = useCallback(async (resumoId) => {
        try {
            if (!resumoId) {
                showMessage('Resumo de caixa não informado.', 'warning');
                return false;
            }

            const pdf = await buscarResumoCaixaPdf(resumoId, 77);
            return await imprimirPdfBlob(pdf, {
                frameId: 'resumo-caixa-pdf-print-frame',
                titulo: 'Resumo de caixa',
                mensagemErro: 'Não foi possível abrir a impressão do resumo de caixa.',
            });
        } catch (error) {
            showMessage(`Erro ao gerar o resumo de caixa: ${error?.message || error}`, 'danger');
            console.error(error);
            return false;
        }
    }, [imprimirPdfBlob, showMessage]);

    return (
        <PrinterCaixaContext.Provider value={{ printResumoCaixa }}>
            {children}
        </PrinterCaixaContext.Provider>
    );
};

// Hook para utilizar o contexto de resumo de caixa
export const usePrinterCaixa = () => {
    const context = useContext(PrinterCaixaContext);
    if (!context) {
        throw new Error('usePrinterCaixa must be used within a PrinterCaixaProvider');
    }
    return context;
};
